module.exports = __webpack_public_path__ + "static/media/es-pv.804e31e4.svg";